// Clevernook — scripts vanilla para las secciones cn-*

function cnInitReveals() {
  var els = document.querySelectorAll('.cn-reveal:not(.cn-visible)');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('cn-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('cn-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el, i) {
    el.style.setProperty('--cn-i', i % 8);
    observer.observe(el);
  });
}

function cnInitContadores() {
  var els = document.querySelectorAll('[data-cn-contador]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var fin = parseFloat(el.getAttribute('data-cn-contador')) || 0;
      var dur = 1200;
      var inicio = null;
      function paso(ts) {
        if (inicio === null) inicio = ts;
        var progreso = Math.min((ts - inicio) / dur, 1);
        var valor = fin * (1 - Math.pow(1 - progreso, 3));
        el.textContent = (Number.isInteger(fin) ? Math.round(valor) : valor.toFixed(1)).toString().replace('.', ',');
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = fin.toString().replace('.', ',');
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { observer.observe(el); });
}

function cnInitGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-cn-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-cn-imagen-principal]');
    var minis = galeria.querySelectorAll('[data-cn-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-cn-src');
        var srcset = mini.getAttribute('data-cn-srcset');
        if (!src) return;
        principal.src = src;
        if (srcset) principal.srcset = srcset;
        minis.forEach(function (m) { m.classList.remove('cn-mini-activa'); });
        mini.classList.add('cn-mini-activa');
      });
    });
  });
}

function cnInitVariantes() {
  var forms = document.querySelectorAll('[data-cn-producto]');
  forms.forEach(function (root) {
    var dataEl = root.querySelector('[data-cn-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selects = root.querySelectorAll('[data-cn-opcion]');
    var inputId = root.querySelector('[data-cn-input-id]');
    var precioEl = root.querySelector('[data-cn-precio]');
    var precioCompareEl = root.querySelector('[data-cn-precio-compare]');
    var botonComprar = root.querySelector('[data-cn-boton-comprar]');
    var estadoEl = root.querySelector('[data-cn-estado]');

    function formatearPrecio(centavos) {
      return (centavos / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function varianteActual() {
      var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === valores[i]; });
      });
    }

    function actualizar() {
      var v = varianteActual();
      if (!v) return;
      if (inputId) inputId.value = v.id;
      if (precioEl) precioEl.textContent = formatearPrecio(v.price);
      if (precioCompareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          precioCompareEl.textContent = formatearPrecio(v.compare_at_price);
          precioCompareEl.style.display = '';
        } else {
          precioCompareEl.style.display = 'none';
        }
      }
      if (botonComprar) botonComprar.disabled = !v.available;
      if (estadoEl) estadoEl.textContent = v.available ? '' : 'Agotado';
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  cnInitReveals();
  cnInitContadores();
  cnInitGaleriaProducto();
  cnInitVariantes();
});
